import { CompositeSpecification } from './specification';
import * as queryValue from '../../query.const';
import util from '../../../utils/util';

/**
 * 首屏自动弹出订单弹层
 */
export class PopSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return o.isPop === '1';
  }
}
/**
 * 首屏自动弹出订单
 */
export class OrderPoupSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return (
      o.openType && o.openType.toLowerCase() === queryValue.QUERY_FROM_ORDER
    );
  }
}

/**
 * 首屏自动弹出3d单车
 */
export class ThreeCarSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return (
      o.openType &&
      o.openType.toLowerCase() === queryValue.QUERY_OPENTYPE_3DCAR &&
      o.seriesId > 0
    );
  }
}

/**
 * 首屏自动弹出促销文章弹层
 */
export class PromotionSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return (
      o.openType &&
      o.openType.toLowerCase() === queryValue.QUERY_OPENTYPE_PROMOTION &&
      o.actId
    );
  }
}

/**
 *  首屏自动弹出促销活动弹层
 */
export class SahuanActivitySpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return o.from === queryValue.QUERY_FROM_SAHUAN && o.activityId > 0;
  }
}
/**
 * 首屏自动弹出促销活动弹层
 */
export class PromotionActivitySpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return (
      o.openType &&
      o.openType.toLowerCase() ===
        queryValue.QUERY_OPENTYPE_PROMOTIONACTIVITY &&
      o.actId
    );
  }
}

/**
 * 首屏自动弹出互动游戏
 */
export class DealerActivitySpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    return (
      o.openType &&
      o.openType.toLowerCase() === queryValue.QUERY_OPENTYPE_ACTIVITY &&
      o.actId
    );
  }
}

/**
 * 首屏自动弹出互动游戏
 */
export class DealerActivityIdSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    const canOpen =
      queryValue.CAN_OPEN_ACTIVITY_TYPES.findIndex(
        (t) => t === o.activityType,
      ) >= 0;
    return canOpen && o.activityId;
  }
}
/**
 * 首屏自动弹出视频列表
 */
export class VideoListSpecification extends CompositeSpecification {
  constructor(videoNumInfo) {
    super();
    this.videoNumInfo = videoNumInfo || { allNum: 0, gold: 0 };
  }
  isSatisfiedBy(o) {
    return (
      o.from === queryValue.QUERY_FROM_CLOUDVIDEO &&
      this.videoNumInfo.allNum > 0 &&
      this.videoNumInfo.gold > 0 &&
      !(util.browser.isIos && util.browser.isMobile && util.browser.isQQWeb)
    );
  }
}

/**
 * 红包弹层
 */
export class RedPacketSpecification extends CompositeSpecification {
  constructor(redPacketInfo, dealerId, icsShowState) {
    super();
    this.redPacketInfo = redPacketInfo || [];
    this.dealerId = dealerId;
    this.icsShowState = icsShowState;
  }
  isSatisfiedBy() {
    let dealerId = this.dealerId;
    if (!this.redPacketInfo || !this.redPacketInfo.promotionId) {
      return false;
    }
    if (util.getCookie('hideRedPacketTwoHours_' + dealerId) === 'true') {
      return false;
    }
    return this.icsShowState;
  }
}
/**
 * 分享者红包提示弹层
 */
export class RedPacketSharedTipSpecification extends CompositeSpecification {
  constructor(redPacketList) {
    super();
    this.redPacketList = redPacketList || [];
  }
  getRedPacketPromotionSharedState(o) {
    const SHARED_RED_PACKET_SHOW_KEY = 'SHARED_RED_PACKET_SHOW_KEY';
    if (!util.browser.isApp) {
      return false;
    }
    let promotionId = o.promotionId;
    if (!promotionId) {
      return false;
    }
    try {
      const sessionkey =
        SHARED_RED_PACKET_SHOW_KEY + '?promotionId=' + promotionId;
      if (window.sessionStorage.getItem(sessionkey)) {
        return false;
      }
      window.sessionStorage.setItem(sessionkey, true);
    } catch {
      return true;
    }
    if (window[SHARED_RED_PACKET_SHOW_KEY]) {
      return false;
    }
    window[SHARED_RED_PACKET_SHOW_KEY] = true;
    return true;
  }
  isSatisfiedBy(o) {
    let redPacketId = o.promotionId;
    if (!redPacketId) {
      return false;
    }
    return (
      redPacketId &&
      this.getRedPacketPromotionSharedState(o) &&
      this.redPacketList.length > 0
    );
  }
}

/**
 * 分享红包弹层
 */
export class RedPacketSharedSpecification extends CompositeSpecification {
  constructor(redPacketList) {
    super(redPacketList);
    this.redPacketList = redPacketList || [];
  }
  isSatisfiedBy(o) {
    const activityId = o.activityId || 0;
    const promotionId = o.promotionId || '';
    const redPacketActivityType = 6666; // 优惠券活动类型
    const activityType = o.activityType || '';
    return (
      activityType === redPacketActivityType &&
      (promotionId || activityId > 0) &&
      this.redPacketList.length > 0
    );
  }
}

/**
 * 开屏广告弹层
 */
export class WelcomeAdSpecification extends CompositeSpecification {
  constructor(icsShowState) {
    super();
    this.icsShowState = icsShowState;
  }
  isSatisfiedBy() {
    if (util.getCookie('hideKaipingTwoHours') === 'true') {
      return false;
    }
    return this.icsShowState;
  }
}

/**
 * 首屏自动弹出-VR带看引导
 */
export class VRShowTapeGuideSpecification extends CompositeSpecification {
  isSatisfiedBy(o) {
    // 当前店铺【VR带看】功能露出且在08：00-21：59时间段期间时弹，否则不弹
    // 优先级高于其他弹层，与其他弹层互斥（提示弹出时，商家红包不弹），若不弹出vr引导弹层，则正常弹红包
    const isRealtimeGuide = o.openType === queryValue.QUERY_REALTIME_GUIDE;
    return isRealtimeGuide;
  }
}
